import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next'; // Import I18nextProvider
import i18n from './i18n';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import './styles/app.css'
import Contact from './Components/Contact';
import Quality from './Components/Quality';
import Spices from './Components/Spices';
import SpicesDetail from './Components/SpicesDetail';
function App() {
  return (
   
    <I18nextProvider i18n={i18n}>
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/spice" element={<Spices/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/quality" element={<Quality/>} />
          <Route path="/spice/:id" element={<SpicesDetail />} />
          {/* Add more routes as needed */}
        </Routes>
      </div>
    </Router>
    </I18nextProvider>
    
  );
}

export default App;
